import React from 'react';
import { Trans } from 'react-i18next';
import Icon from 'shared/components/Icon';

const GoogleTranslation = () => {
  return (
    <div className="google-translate-container">
      <Trans
        i18nKey="responses.powered_by_google"
        components={{
          google: (
            <Icon
              className="google-logo"
              onClick={() =>
                window.open('https://translate.google.com/', '_blank')
              }
              glyph="google_color"
              width="46px"
              height="18px"
              fill="none"
              color="yellow"
            />
          ),
        }}
      />
    </div>
  );
};

export default GoogleTranslation;
